import { render, staticRenderFns } from "./infoAddress.vue?vue&type=template&id=8dec847c&scoped=true"
import script from "./infoAddress.vue?vue&type=script&lang=js"
export * from "./infoAddress.vue?vue&type=script&lang=js"
import style0 from "./infoAddress.vue?vue&type=style&index=0&id=8dec847c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dec847c",
  null
  
)

export default component.exports